import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '@/store'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '@/model/statement'
import processStatements from './process-statements';

export default async function fetchStatements(context: BareActionContext<StatementState, RootState>) {
    statementStore.commitSetIsLoading({isLoading: true})
    statementUtils.statementService.fetchStatements(statementStore.state.statementQuery).then((statements: IStatement[]) => {
        processStatements(context, statements)
    })

    return
}
